import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Button,
  Divider,
  FormControlLabel,
  makeStyles,
  Paper,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  AllInboxRounded,
  ExpandMore,
  HourglassEmptyRounded,
  MoveToInbox,
} from "@material-ui/icons";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../Can";
import NewTicketModal from "../NewTicketModal";
import TabPanel from "../TabPanel";
import TicketsList from "../TicketsList";
import TicketsQueueSelect from "../TicketsQueueSelect";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  tabsHeader: {
    flex: "none",
    backgroundColor: theme.palette.background.default,
  },
  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: 8,
  },
  tab: {
    minWidth: 120,
    width: 120,
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
  },
  serachInputWrapper: {
    flex: 1,
    backgroundColor: theme.palette.background.default,
    display: "flex",
    borderRadius: 40,
    padding: 4,
    marginRight: theme.spacing(1),
  },
  searchIcon: {
    color: theme.palette.primary.main,
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },
  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 25,
    padding: "10px",
    outline: "none",
  },
  badge: {
    right: 0,
  },
  show: {
    display: "block",
  },
  hide: {
    display: "none !important",
  },
}));

const TicketsManager = ({ onClickActionsItem }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [searchParam, setSearchParam] = useState("");
  const [pesquisaContato, setPesquisaContato] = useState("");
  const [pesquisaNumeroTicket, setPesquisaNumeroTicket] = useState("");
  const [tab, setTab] = useState("open");
  const [tabSelecionada, setTabSelecionada] = useState("open");
  const [tabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const { user } = useContext(AuthContext);
  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN") {
      setShowAllTickets(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSetTab = (tabAtual = "search") => {
    setTab("");
    setTimeout(() => setTab(tabAtual), 0);
  };

  const handleSetTabByItemAction = (proximaTab) => {
    if (proximaTab === "closed") proximaTab = "open";
    setTab("");
    setTimeout(() => setTab(proximaTab), 0);
    setTabSelecionada("");
    setTimeout(() => setTabSelecionada(proximaTab), 0);
  };

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    setSearchParam(searchedTerm);
    if (
      searchedTerm === "" &&
      pesquisaContato === "" &&
      pesquisaNumeroTicket === ""
    ) {
      handleSetTab(tabSelecionada);
    } else if (tab !== "search") {
      setTab("search");
    } else {
      handleSetTab();
    }
  };

  const handlePesquisaContato = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    setPesquisaContato(searchedTerm);
    if (
      searchedTerm === "" &&
      searchParam === "" &&
      pesquisaNumeroTicket === ""
    ) {
      handleSetTab(tabSelecionada);
    } else if (tab !== "search") {
      setTab("search");
    } else {
      handleSetTab();
    }
  };

  const handlePesquisaNumeroTicket = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    setPesquisaNumeroTicket(searchedTerm);
    if (searchedTerm === "" && pesquisaContato === "" && searchParam === "") {
      handleSetTab(tabSelecionada);
    } else if (tab !== "search") {
      setTab("search");
    } else {
      handleSetTab();
    }
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
    setTabSelecionada(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  useEffect(() => {
    const funcao = onClickActionsItem;
    handleSetTabByItemAction(funcao);
  }, [onClickActionsItem]);

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(e) => setNewTicketModalOpen(false)}
      />
      <Accordion elevation={1} square>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography>Filtros de Pesquisa</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Paper elevation={0} square>
            <Divider style={{ marginBottom: "16px" }} />
            <TextField
              style={{ marginBottom: "10px", width: "100%" }}
              variant="outlined"
              size="small"
              placeholder={"Filtro por Mensagens"}
              value={searchParam}
              onChange={handleSearch}
            />
            <TextField
              style={{ marginBottom: "10px", width: "100%" }}
              variant="outlined"
              size="small"
              placeholder="Filtro por Contato"
              value={pesquisaContato}
              onChange={handlePesquisaContato}
            />
            <TextField
              style={{ marginBottom: "10px", width: "100%" }}
              variant="outlined"
              size="small"
              placeholder="Filtro por Número do Ticket"
              value={pesquisaNumeroTicket}
              onChange={handlePesquisaNumeroTicket}
            />
          </Paper>
        </AccordionDetails>
      </Accordion>

      <Paper elevation={0} square className={classes.tabsHeader}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="icon label tabs example"
        >
          <Tab
            value={"open"}
            icon={<MoveToInbox />}
            label={
              <Badge
                className={classes.badge}
                badgeContent={openCount}
                overlap="rectangular"
                max={9999}
                color="secondary"
              >
                {t("tickets.tabs.open.title")}
              </Badge>
            }
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"pending"}
            icon={<HourglassEmptyRounded />}
            label={
              <Badge
                className={classes.badge}
                badgeContent={pendingCount}
                overlap="rectangular"
                max={9999}
                color="secondary"
              >
                {t("ticketsList.pendingHeader")}
              </Badge>
            }
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"closed"}
            icon={<AllInboxRounded />}
            label={t("tickets.tabs.closed.title")}
            classes={{ root: classes.tab }}
          />
        </Tabs>
      </Paper>
      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setNewTicketModalOpen(true)}
        >
          {t("ticketsManager.buttons.newTicket")}
        </Button>
        <Can
          role={user.profile}
          perform="tickets-manager:showall"
          yes={() => (
            <FormControlLabel
              label={t("tickets.buttons.showAll")}
              labelPlacement="start"
              control={
                <Switch
                  size="small"
                  checked={showAllTickets}
                  onChange={() => setShowAllTickets((prevState) => !prevState)}
                  name="showAllTickets"
                  color="primary"
                />
              }
            />
          )}
        />
        <TicketsQueueSelect
          style={{ marginLeft: 6 }}
          selectedQueueIds={selectedQueueIds}
          userQueues={user?.queues}
          onChange={(values) => setSelectedQueueIds(values)}
        />
      </Paper>
      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            onClickActionsItem={handleSetTabByItemAction}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            onClickActionsItem={handleSetTabByItemAction}
          />
        </Paper>
      </TabPanel>
      <TabPanel value={tab} name="pending" className={classes.ticketsWrapper}>
        <TicketsList
          status="pending"
          showAll={true}
          selectedQueueIds={selectedQueueIds}
          onClickActionsItem={handleSetTabByItemAction}
        />
      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={true}
          selectedQueueIds={selectedQueueIds}
          onClickActionsItem={handleSetTabByItemAction}
        />
      </TabPanel>
      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        <TicketsList
          searchParam={searchParam}
          pesquisaContato={pesquisaContato}
          pesquisaNumeroTicket={pesquisaNumeroTicket}
          showAll={true}
          selectedQueueIds={selectedQueueIds}
        />
      </TabPanel>
    </Paper>
  );
};

export default TicketsManager;
